import * as React from 'react';
import { Box } from '@mui/material';
import Loading from '../../../../auxiliares/loading';
import UserTable from './usersButtonExcel'
import { options } from '@config';

const ItemTableContainer = () => {
    const [items, setItems] = React.useState([]);
    const [loading, setLoading] = React.useState(true); 


    const handleListUsers = async () => {
        const response = await fetch((options.api.url + "user"), {
            method: 'GET',
            mode: "cors",
            headers: {
                'Content-Type': 'application/json'
            },
        });
    
        const data = await response.json();

        const items =  data.usersSearched

        return items
    }

    React.useEffect(()=> {
        const db = handleListUsers().then((e) => {
            setItems(e);
            setLoading(false);
        });
    },[loading]);

    return (
        <Box>
            {loading ? <Loading/>: <UserTable items={items}/>}
        </Box>
    )
}

export default ItemTableContainer;